import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getCurrentSite } from 'modules/sites/selectors'


const mapStateToProps = createStructuredSelector({ currentSite: getCurrentSite });

export default Component => {
  const WrappedComponent = ({ currentSite, ...props }) => {
    if (!currentSite) {
      return null
    }

    return <Component currentSite={ currentSite } { ...props } />
  }

  WrappedComponent.propTypes = {
    currentSite: PropTypes.shape({
      key: PropTypes.string.isRequired,
    }),
  }

  return connect(mapStateToProps)(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/modules/sites/containers/with-current-site.js